import { render, staticRenderFns } from "./DialogoDeCadastro.vue?vue&type=template&id=b67ce9f4"
import script from "./DialogoDeCadastro.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogoDeCadastro.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports